module.exports = __webpack_public_path__ + "img/tcndxq_img2-6.6b1d3d85.png";